import GET_DRAFTS_NEWS from "./getDraftsNews"
import GET_DRAFTS_NEWS_WAVE from "./getDraftsNewsWave"
import GET_NEWS from "./getNews"
import GET_NEWS_LIST from "./getNewsList"
import GET_OUTLET_BY_ID from "./getOutletById"
import GET_OUTLETS from "./getOutlets"
import SEARCH_NEWS from "./searchNews"
import SEARCH_OUTLETS from "./searchOutlets"

export default {
  GET_DRAFTS_NEWS,
  GET_DRAFTS_NEWS_WAVE,
  GET_NEWS,
  GET_NEWS_LIST,
  GET_OUTLETS,
  GET_OUTLET_BY_ID,
  SEARCH_NEWS,
  SEARCH_OUTLETS
}
